<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <div class="columns">
          <div class="column"></div>
          <div class="column is-half has-text-centered">
            <img
              id="logo-navbar"
              src="../../assets/img/logo-smart-orange-outline.png"
              width="170"
              height="22"
              alt="Logo Onii"
              title="Onii"
            />

            <h1 class="is-size-3 has-text-weight-semibold">Redefinir Senha</h1>

            <h2 class="subtitle">
              Escolha uma senha com, no mínimo, 6 caracteres
            </h2>

            <form @submit.prevent="resetPassword">
              <b-field>
                <b-input
                  size="is-medium"
                  v-model="password"
                  class="is-expanded"
                  type="password"
                  placeholder="Senha"
                  password-reveal
                ></b-input>
              </b-field>

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="passwordConfirmation"
                  class="is-expanded"
                  type="password"
                  placeholder="Confirmação"
                  password-reveal
                ></b-input>
              </b-field>

              <button
                class="button is-primary is-medium is-fullwidth has-text-weight-bold"
              >
                Redefinir Senha
              </button>
            </form>
          </div>
          <div class="column"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common.js";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      resetToken: "",
      password: "",
      passwordConfirmation: ""
    };
  },

  methods: {
    resetPassword() {
      this.isLoading = true;
      this.$store
        .dispatch("resetPassword", {
          resetToken: this.resetToken,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message: "Você já pode fazer login com sua nova senha ;)",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$router.push("/"),
              onCancel: () => this.$router.push("/")
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.resetToken = this.$route.query.resetToken;
  }
};
</script>

<style>
form {
  width: 80%;
  margin: auto;
}
</style>
